import login from './login.json';

import labels from '../default/labels.json';
import common from '../default/common.json';
import newsletters from '../default/newsletters.json';
import polls from '../default/polls.json';
import students from '../default/students.json';
import employees from '../default/employees.json';
import orgs from '../default/orgs.json';
import wiki from '../default/wiki.json';
import settings from '../default/settings.json';

const messages = {
  labels,
  common,
  login,
  newsletters,
  polls,
  students,
  employees,
  orgs,
  wiki,
  settings
};

export default messages;